import {createFileRoute} from '@tanstack/react-router';
import {ErrorPage} from 'pages';

export const Route = createFileRoute('/error')({
  component: ErrorPage,
});
